/* ============================================================================
   MACHANG — Shopify theme behaviour.
   Talks to the Shopify AJAX Cart API for a headless-feeling cart drawer while
   staying a native Liquid theme (native checkout, discounts, accounts).
   Wishlist is stored in localStorage (swap for a wishlist app/metafield later).
   ========================================================================== */
(function () {
  "use strict";
  var CFG = window.MACHANG || {};
  var routes = CFG.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* --------------------------------------------------- money */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || "AED {{amount}}";
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* --------------------------------------------------- toast */
  var toastTimer;
  function toast(msg) {
    var host = $("#ToastHost");
    if (!host) return;
    host.innerHTML = '<div class="toast"><span class="ok">✓</span>' + msg +
      '<button data-cart-toggle>View bag</button></div>';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { host.innerHTML = ""; }, 2600);
  }

  /* --------------------------------------------------- cart state + drawer */
  function getCart() {
    return fetch(routes.cart_url + ".js", { headers: { "Content-Type": "application/json" } }).then(function (r) { return r.json(); });
  }
  function renderDrawer(cart) {
    var host = $("#CartDrawer");
    if (!host) return;
    document.body.style.overflow = "hidden";
    var threshold = (CFG.strings && CFG.strings.freeShipThreshold) || 40000;
    var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
    var remain = Math.max(0, threshold - cart.total_price);
    var msg = cart.total_price === 0 ? "Add " + formatMoney(threshold) + " to unlock free delivery"
      : cart.total_price >= threshold ? "🎉 You unlocked free same-day delivery"
      : "You are " + formatMoney(remain) + " away from free delivery";

    var body;
    if (!cart.items.length) {
      body = '<div class="cart-empty"><div style="font-size:40px">🛍️</div>' +
        '<div class="h-display" style="font-size:20px">Your bag is empty</div>' +
        '<p style="font-size:13px;color:var(--muted);margin:0">Nothing to wear out yet. Let\'s fix that.</p>' +
        '<a class="btn btn-primary btn-sm" href="/collections/all">Shop the drop →</a></div>';
    } else {
      var lines = cart.items.map(function (it, i) {
        var img = it.image ? '<div class="thumb" style="background-image:url(' + it.image + ');background-size:cover"></div>' : '<div class="thumb"></div>';
        return '<div class="cart-line">' + img + '<div class="info">' +
          '<div style="display:flex;justify-content:space-between;gap:8px"><div style="font-weight:600;font-size:14px;line-height:1.2">' + it.product_title + '</div>' +
          '<button data-remove="' + (i + 1) + '" style="background:none;border:none;color:rgba(244,242,234,.45);cursor:pointer;font-size:16px;padding:0">✕</button></div>' +
          '<div style="font-size:12px;color:var(--muted);margin:3px 0 auto">' + (it.variant_title || "") + '</div>' +
          '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px">' +
          '<div class="qty"><button data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '">+</button></div>' +
          '<div style="font-weight:700;font-size:15px">' + formatMoney(it.final_line_price) + '</div></div></div></div>';
      }).join("");
      body =
        '<div class="ship-bar"><div class="msg">' + msg + '</div><div class="ship-track"><span style="width:' + pct + '%"></span></div></div>' +
        '<div class="cart-lines">' + lines + '</div>' +
        '<div class="cart-foot">' +
          '<div style="display:flex;justify-content:space-between;margin-bottom:6px;font-size:14px;color:var(--muted2)"><span>Subtotal</span><span>' + formatMoney(cart.items_subtotal_price) + '</span></div>' +
          '<div style="display:flex;justify-content:space-between;margin-bottom:16px;font-weight:700;font-size:19px"><span>Total</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
          '<a class="btn btn-primary btn-block" href="/checkout">Checkout →</a>' +
          '<div style="text-align:center;font-size:12px;color:rgba(244,242,234,.45);margin-top:10px">🔒 Secure checkout · Powered by Shopify</div></div>';
    }
    host.innerHTML = '<div class="overlay" data-cart-close></div>' +
      '<aside class="cart-drawer"><div class="cart-head"><div class="t">Your bag (' + cart.item_count + ')</div>' +
      '<button class="close-btn" data-cart-close>✕</button></div>' + body + '</aside>';
    updateCount(cart.item_count);
  }
  function openDrawer() { getCart().then(renderDrawer); }
  function closeDrawer() { var h = $("#CartDrawer"); if (h) h.innerHTML = ""; document.body.style.overflow = ""; }
  function updateCount(n) {
    $$("[data-cart-count]").forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }

  function addToCart(id, qty) {
    return fetch(routes.cart_add_url + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { toast(res.description || "Could not add item"); return; }
      toast((res.product_title || "Item") + " " + ((CFG.strings && CFG.strings.added) || "added"));
      openDrawer();
    });
  }
  function changeLine(line, qty) {
    return fetch(routes.cart_change_url + ".js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderDrawer);
  }

  /* --------------------------------------------------- wishlist (localStorage) */
  var WKEY = "machang:wishlist";
  function wish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function toggleWish(handle) {
    var w = wish(), i = w.indexOf(handle);
    if (i >= 0) w.splice(i, 1); else w.push(handle);
    localStorage.setItem(WKEY, JSON.stringify(w));
    paintWish();
    toast(i >= 0 ? "Removed from wishlist" : "Saved to wishlist");
  }
  function paintWish() {
    var w = wish();
    $$("[data-wish]").forEach(function (b) {
      var on = w.indexOf(b.getAttribute("data-wish")) >= 0;
      b.classList.toggle("is-on", on);
      var svg = b.querySelector("svg");
      if (svg) { svg.setAttribute("fill", on ? "var(--a2-hot)" : "none"); svg.setAttribute("stroke", on ? "var(--a2-hot)" : "currentColor"); }
    });
  }

  /* --------------------------------------------------- product variant picker */
  function initProduct() {
    var form = $("#ProductForm");
    if (!form) return;
    var select = $("[data-variant-select]", form);
    var priceEl = $("[data-price]");
    var addBtn = $("[data-add-btn]", form);
    var variants = [];
    try { variants = JSON.parse($("[data-product-json]").textContent); } catch (e) {}
    var chosen = {};
    $$("[data-option-index]", form).forEach(function (row) {
      var idx = parseInt(row.getAttribute("data-option-index"), 10);
      var sel = $(".size-opt.is-selected", row);
      chosen[idx] = sel ? sel.getAttribute("data-option-value") : null;
    });
    function resolve() {
      var match = variants.filter(function (v) {
        return Object.keys(chosen).every(function (k) { return !chosen[k] || v.options[k] === chosen[k]; });
      })[0];
      if (!match) return;
      if (select) select.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (addBtn) {
        var label = addBtn.getAttribute("data-buy-label") || "Add to bag";
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? label + " · " + formatMoney(match.price) : "Sold out";
      }
    }
    form.addEventListener("click", function (e) {
      var b = e.target.closest(".size-opt");
      if (!b) return;
      e.preventDefault();
      var row = b.closest("[data-option-index]");
      var idx = parseInt(row.getAttribute("data-option-index"), 10);
      $$(".size-opt", row).forEach(function (x) { x.classList.remove("is-selected"); });
      b.classList.add("is-selected");
      chosen[idx] = b.getAttribute("data-option-value");
      resolve();
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var id = select ? select.value : (variants[0] && variants[0].id);
      addToCart(id, 1);
    });
  }

  /* --------------------------------------------------- size guide / mobile nav */
  function sizeGuideHTML() {
    var rows = [["S","104","70","22"],["M","110","72","23"],["L","116","74","24"],["XL","122","76","25"],["XXL","128","78","26"]];
    return '<div class="modal-overlay" data-guide-close><div class="modal" onclick="event.stopPropagation()">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px"><h3 class="h-display" style="font-size:24px;margin:0">Size &amp; fit</h3><button class="close-btn" data-guide-close>✕</button></div>' +
      '<p style="font-size:13px;color:var(--muted2);margin:0 0 20px">Machang runs a relaxed party fit. Between sizes? Size down for a sharper cut. Measurements in cm.</p>' +
      '<div class="size-table"><div class="hrow"><div>Size</div><div>Chest</div><div>Length</div><div>Sleeve</div></div>' +
      rows.map(function (r) { return '<div class="row"><div>' + r[0] + '</div><div>' + r[1] + '</div><div>' + r[2] + '</div><div>' + r[3] + '</div></div>'; }).join("") +
      '</div></div></div>';
  }

  /* --------------------------------------------------- events */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest("[data-cart-toggle]"))) { e.preventDefault(); return openDrawer(); }
    if (t.closest("[data-cart-close]")) return closeDrawer();
    if ((el = t.closest("[data-quick-add]"))) { e.preventDefault(); return addToCart(el.getAttribute("data-quick-add"), 1); }
    if ((el = t.closest("[data-wish]"))) { e.preventDefault(); return toggleWish(el.getAttribute("data-wish")); }
    if ((el = t.closest("[data-remove]"))) return changeLine(parseInt(el.getAttribute("data-remove"), 10), 0);
    if ((el = t.closest("[data-line]"))) return changeLine(parseInt(el.getAttribute("data-line"), 10), parseInt(el.getAttribute("data-qty"), 10));
    if ((el = t.closest("[data-mobilenav]"))) { var open = el.getAttribute("data-mobilenav") === "1"; var mn = $("[data-mobile-nav]"); if (mn) mn.classList.toggle("open", open); document.body.style.overflow = open ? "hidden" : ""; return; }
    if (t.closest("[data-sizeguide]")) { e.preventDefault(); var h = $("#ToastHost"); document.body.insertAdjacentHTML("beforeend", '<div id="GuideHost">' + sizeGuideHTML() + "</div>"); document.body.style.overflow = "hidden"; return; }
    if (t.closest("[data-guide-close]")) { var g = $("#GuideHost"); if (g) g.remove(); document.body.style.overflow = ""; return; }
    if ((el = t.closest("[data-thumb]"))) { var main = $(".pdp-main img"); if (main) main.src = el.style.backgroundImage.slice(5, -2).replace(/width=\d+/, "width=900"); return; }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeDrawer(); var g = $("#GuideHost"); if (g) g.remove(); var mn = $("[data-mobile-nav]"); if (mn) mn.classList.remove("open"); document.body.style.overflow = ""; } });

  /* --------------------------------------------------- init */
  document.addEventListener("DOMContentLoaded", function () { paintWish(); initProduct(); getCart().then(function (c) { updateCount(c.item_count); }); });
})();
